export enum AutoReplyType {
  INVITEE_REIGSTERED = 'Invitee registered',
  INVITEE_PLACED_AN_ORDER = 'Invitee placed an order',
}
